import type { CustomerLink } from "@omnabase/shared";
import { CustomerLinkButtons } from "../inbox/CustomerSide";

/** The customer sidebar round (2026-11-01, brief rule 4 and question 12): the project's customer links on the customer page, filled with this
 *  customer. With a project chosen, that project's links; with "All projects", the links of every project the customer wrote to (a ticket
 *  or a licence there), each group named by its project when more than one has links. Under the header, at every width (the side column is
 *  wide-only). Nothing when no project has any. */
type LinkedProject = { id: string; name: string; customerLinks?: readonly CustomerLink[] };

export function CustomerLinksBlock({ customer, projects }: { customer: { id: string; email: string; name: string }; projects: readonly LinkedProject[] }) {
  const withLinks = projects.filter((p) => (p.customerLinks ?? []).length > 0);
  if (!withLinks.length) return null;
  const who = { email: customer.email, name: customer.name, id: customer.id };
  return (
    <div className="ob-profile__links">
      {withLinks.map((p) => (
        <div key={p.id} className="ob-profile__links-group">
          {withLinks.length > 1 && <span className="ob-profile__links-project">{p.name}</span>}
          <CustomerLinkButtons links={p.customerLinks ?? []} who={who} label={withLinks.length > 1 ? `${p.name} links` : undefined} />
        </div>
      ))}
    </div>
  );
}

/** the projects whose links the page shows: the chosen one, else every project the customer wrote to or holds a licence on, in the workspace's order */
export function linkedProjectsOf<P extends { id: string }>(all: readonly P[], chosen: string | null, used: Iterable<string>): P[] {
  if (chosen) return all.filter((p) => p.id === chosen);
  const ids = new Set(used);
  return all.filter((p) => ids.has(p.id));
}
